import { store } from '@atredux/store'
import { hideToolBar } from '@src/redux/slices/toolSlice'

export async function hideToolBarListener (message: any) {
    console.log('ATBase: Received request to hide toolbar.')

    if (message && message.data && typeof message.data?.hide === 'boolean') {
        const hide = message.data.hide

        store.dispatch(hideToolBar(hide))

        return Promise.resolve(hide)
    } else {
        return Promise.reject(`Invalid request parameters, the 'hide' field is mandatory`)
    }
}
